// extracted by mini-css-extract-plugin
module.exports = {"slider":"GamePreviewSlides_slider_2h-42","slide":"GamePreviewSlides_slide_2zLeG","content":"GamePreviewSlides_content_2qusT","play":"GamePreviewSlides_play_1FP5E"};